import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["navWrap"]

  toggleNav() {
    this.navWrapTarget.classList.toggle("hide")
  }
}
